import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('excesses', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => new Promise((resolve, reject) => {
            axios.get(`excesses/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, { id, data }) => new Promise((resolve, reject) => {
            axios.put(`excesses/${id}`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        confirmExcess: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('confirm_excess', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        metrics: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('excess_metrics', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
